
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/IssueProjectsBlock/IssueProjectsBlock.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./IssueProjectsBlock.html');
        
        var script = require('./IssueProjectsBlock.ts').default;
        module.exports = require('./IssueProjectsBlock.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    